module.exports = __webpack_public_path__ + "img/img4.1ca1b151.png";